import React, { useState } from 'react';
import VehicleInfo from '../components/system/VehicleInfo';
import UserManager from '../components/system/UserManager';
import EngineerManager from '../components/system/EngineerManager';
import RecallData from '../components/system/RecallData';
import NoticeManager from '../components/system/NoticeManager';
import ExcellImport from '../components/system/ExcellImport'; 
import SmsTemplate from '../components/system/SmsTemplate';
import ReportBuilder from '../components/system/ReportBuilder';
import DevMemo from '../components/system/DevMemo';

const SystemConfig = () => {
  const [selectedMenuId, setSelectedMenuId] = useState(null);

  const menuItems = [
    { id: 1, title: "기초차량정보", icon: "🚗", desc: "차량 모델 및 제원 마스터 관리", component: <VehicleInfo /> },
    { id: 2, title: "사용자관리", icon: "👥", desc: "권한 그룹 및 신규 가입 승인", component: <UserManager /> },
    { id: 3, title: "엔지니어관리", icon: "👨‍🔧", desc: "AS 및 리콜 전담 인력 매핑", component: <EngineerManager /> },
    { id: 4, title: "리콜기초데이터", icon: "📢", desc: "모델별 결함 및 대응 가이드", component: <RecallData /> },
    { id: 5, title: "공지사항관리", icon: "📝", desc: "대시보드 실시간 이슈 제어", component: <NoticeManager /> },
    { id: 6, title: "초기데이터(엑셀)", icon: "📥", desc: "대량 데이터 일괄 DB 포팅", component: <ExcellImport /> },
    // ※ 컴포넌트 파일명은 SmsTemplate 이지만 내용은 '행위 이력 감사(Audit Log)' 화면이다(메뉴명과 일치시킴).
    { id: 7, title: "행위이력감사", icon: "🛡️", desc: "전 부문 생성·수정·삭제 이력 추적", component: <SmsTemplate /> },
    { id: 8, title: "리포트제작", icon: "📊", desc: "서비스 통계 및 매출 분석", component: <ReportBuilder /> },
    { id: 9, title: "개발메모관리", icon: "📒", desc: "시스템 업데이트 기록 및 메모", component: <DevMemo /> },
  ];

  // 메뉴 메인 그리드화면 (사장님의 기존 대시보드 뷰 스타일 규격 100% 유지)
  if (!selectedMenuId) {
    return (
      <div style={{ 
        padding: '40px 20px', 
        maxWidth: '1000px', 
        margin: '0 auto'    
      }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '40px', textAlign: 'center' }}>⚙️ 시스템 설정 커맨드 센터</h1>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(3, 1fr)', 
          gap: '20px' 
        }}>
          {menuItems.map(item => (
            <div 
              key={item.id}
              onClick={() => setSelectedMenuId(item.id)}
              style={{
                background: 'white', padding: '25px', borderRadius: '12px',
                border: '1px solid #e1e8ed', cursor: 'pointer',
                transition: 'all 0.2s', boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
                display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 15px rgba(0,0,0,0.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
              }}
            >
              <div style={{ fontSize: '40px', marginBottom: '15px' }}>{item.icon}</div>
              <h3 style={{ margin: '0 0 10px 0', color: '#2c3e50', fontSize: '17px' }}>{item.title}</h3>
              <p style={{ fontSize: '12px', color: '#7f8c8d', margin: 0, lineHeight: '1.4' }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const currentMenu = menuItems.find(i => i.id === selectedMenuId);
  // 🚀 [핵심 포인트] 선택된 메뉴가 개발메모관리(id: 9)인지 여부를 판별하는 플래그 스위치
  const isDevMemo = selectedMenuId === 9;

  return (
    <div style={{ 
      padding: isDevMemo ? '20px 0px' : '40px 20px', 
      maxWidth: isDevMemo ? '100%' : '1100px', // 🚀 개발메모관리일 때는 가로 폭 제한(1100px)을 해제하여 부모의 Full HD 폭을 100% 흡수
      margin: isDevMemo ? '0' : '0 auto',
      width: '100%',
      boxSizing: 'border-box'
    }}>
      {/* 부모가 제공해주는 통합 단독 상단 바 정렬 */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '25px', paddingLeft: isDevMemo ? '5px' : '0px' }}>
        <button 
          onClick={() => setSelectedMenuId(null)}
          style={{ padding: '8px 15px', marginRight: '15px', cursor: 'pointer', background: '#eee', border: 'none', borderRadius: '6px', fontWeight: 'bold', color: '#475569' }}
        >
          ← 목록으로
        </button>
        <h1 style={{ color: '#2c3e50', margin: 0, fontSize: '24px', fontWeight: '800' }}>{currentMenu.icon} {currentMenu.title}</h1>
      </div>

      {/* 🚀 [디자인 가둠 장벽 해소] 개발메모관리일 때는 겉면의 답답한 흰색 패딩 상자 격벽을 완전히 없애고 소스코드가 직접 화면을 지배하도록 분기 연동 */}
      {isDevMemo ? (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
          {currentMenu.component}
        </div>
      ) : (
        <div style={{ background: 'white', padding: '30px', borderRadius: '12px', border: '1px solid #ddd', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
          {currentMenu.component}
        </div>
      )}
    </div>
  );
};

export default SystemConfig;